import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/partner-programs/PageContent.tsx");
